// src/helpers/axiosConfig.js
import axios from 'axios';

import { toast } from 'react-toastify';
axios.defaults.withCredentials = true;
//axios.defaults.baseURL = 'http://localhost:3001';

const axiosInstance = axios.create({
  baseURL: 'http://localhost:3001', // Adresse de votre backend
  timeout: 5000, // Délai d'attente de 5 secondes pour détecter un problème de connexion
});

// Intercepteur pour capturer les erreurs réseau
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      // Erreur réseau détectée
      toast.error('Le serveur est momentanément inaccessible. Veuillez réessayer plus tard.');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
